import React, { Component } from "react";
import "./ErrorBoundary.scss";
import { trackException } from "../../../observability/appInsights";
import logger from "utils/logger";

const SadIcon = "/assets/img/sad-emoticon.svg";
/**
 * This component will catch component level errors and render an `error occurred` message.
 *
 * nb: in development the builtin react overlay will still show up
 */
class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
			error: null,
			errorInfo: null
		};
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		const boundaryName = this.props.boundaryName || "ErrorBoundary";

		// Log the error to console for debugging
		logger.error('ErrorBoundary caught an error:', error);
		logger.error('Error message:', error.message);
		logger.error('Error stack:', error.stack);
		logger.error('Error Info:', errorInfo);
		logger.error('Component Stack:', errorInfo.componentStack);

		trackException(error, {
			boundary: boundaryName,
			componentStack: errorInfo?.componentStack || "",
			path: typeof window !== "undefined" ? window.location.pathname : "",
		});
		
		// Also log to see what specific error is happening
		if (error.message) {
			logger.error('Specific error message:', error.message);
		}

		// Store error details for debugging
		this.setState({
			error: error,
			errorInfo: errorInfo
		});
	}

	render() {
		if (this.state.hasError) {
			let error = `Something unexpected happened on this page`;
			
			// In development, show actual error details
			if (process.env.NODE_ENV === 'development' && this.state.error) {
				return (
					<div className="error-container">
						<img src={SadIcon} className="error-icon" alt="sad" />
						<p className="error-message">Development Error: {this.state.error.message}</p>
						<details style={{ marginTop: '1rem', textAlign: 'left', maxWidth: '800px' }}>
							<summary>Error Stack Trace</summary>
							<pre style={{ 
								fontSize: '0.7rem', 
								overflow: 'auto', 
								maxHeight: '300px', 
								background: '#f5f5f5', 
								padding: '1rem',
								whiteSpace: 'pre-wrap'
							}}>
								{this.state.error.stack}
							</pre>
						</details>
						{this.state.errorInfo && (
							<details style={{ marginTop: '1rem', textAlign: 'left', maxWidth: '800px' }}>
								<summary>Component Stack</summary>
								<pre style={{ 
									fontSize: '0.7rem', 
									overflow: 'auto', 
									maxHeight: '300px', 
									background: '#f5f5f5', 
									padding: '1rem',
									whiteSpace: 'pre-wrap'
								}}>
									{this.state.errorInfo.componentStack}
								</pre>
							</details>
						)}
						<button onClick={() => window.location.reload()}>Reload page</button>
					</div>
				);
			}
			
			return (
				<div className="error-container">
					<img src={SadIcon} className="error-icon" alt="sad" />
					<p className="error-message">{error}</p>
					<button onClick={() => window.location.reload()}>Reload page</button>
				</div>
			);
		}

		return this.props.children;
	}
}
export default ErrorBoundary;
